export default __webpack_public_path__ + "static/media/menu.b4c38ff5.svg";